import React from 'react';
import { useSelector } from 'react-redux';
import { useRouteMatch } from 'react-router-dom';
import MainTemplate from 'pages/templates/MainTemplate';
import MbTabs from 'components/organisms/MbTabs';

import Statistics from './Statistics';
import KeywordDetail from './KeywordDetail';

const Report = () => {
  let { path } = useRouteMatch();
  const { menu } = useSelector(({ menu }) => ({
    menu: menu.list === null ? new Map() : menu.list,
  }));

  const tabList = () => {
    for (let curMenu of menu.values()) {
      if (typeof curMenu.subMenu !== 'undefined') {
        const cur = curMenu.subMenu.get(path);
        if (typeof cur !== 'undefined') {
          // 현재 2dapth url에 매칭되는 것이 있으면 그 메뉴의 하위 tab 반환
          return cur.subMenu;
        }
      }
    }
  };

  return (
    <MainTemplate>
      <MbTabs
        name="KeywordReport"
        tabMenuList={tabList()}
        tabs={{
          '/keywordcenter/report/amt': {
            tabComponent: <Statistics type="advrtsAmt" />,
          },
          '/keywordcenter/report/keyword': {
            tabComponent: <Statistics type="kwrdNm" />,
          },
          '/keywordcenter/report/keywordDetail': {
            tabComponent: <KeywordDetail />,
            isPop: 1,
          },
        }}
        isModal={false}
      />
    </MainTemplate>
  );
};

export default Report;
